import apibase from './BaseAPI';

const isEmailUnique = async (params) => {
    try {
        const res = await apibase.post('/share/isEmailUnique', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const isClientEmailUnique = async (params) => {
    try {
        const res = await apibase.post('/share/isClientEmailUnique', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getCurrentVersion = async (params) => {
    try {
        const res = await apibase.post('/share/getCurrentVersion', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const isMobileUnique = async (params) => {
    try {
        const res = await apibase.post('/share/isMobileUnique', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const isIdentityUnique = async (params) => {
    try {
        const res = await apibase.post('/share/isIdentityUnique', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const getEmailByRole = async (params) => {
    try {
        const res = await apibase.post('/share/getEmailByRole', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const getMobileByRole = async (params) => {
    try {
        const res = await apibase.post('/share/getMobileByRole', params)
        return res.data

    } catch (err) {
        throw err
    }

}

const getNewId = async () => {
    try {
        const res = await apibase.post('/share/getNewId')
        return res.data

    } catch (err) {
        throw err
    }
}

const getStateAreas = async () => {
    try {
        const res = await apibase.get('/share/stateAreas')
        return res.data

    } catch (err) {
        throw err
    }
}

const getICData = async (params) => {
    try {
        const res = await apibase.post('/share/scanIC', params)
        return res.data

    } catch (err) {
        throw err
    }
}

export default {
    isEmailUnique: isEmailUnique,
    isClientEmailUnique: isClientEmailUnique,
    getCurrentVersion: getCurrentVersion,
    isMobileUnique: isMobileUnique,
    isIdentityUnique: isIdentityUnique,
    getNewId: getNewId,
    getStateAreas: getStateAreas,
    getICData: getICData,
    getEmailByRole: getEmailByRole,
    getMobileByRole: getMobileByRole,

}